import { ETAB_ROUTES } from "@etab/config";

import TemporaryDetailRoot from "./TemporaryDetail.root.vue";
import AppliedPage from "./Applied.page.vue";
import SelectedPage from "./Selected.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.recruitment.temporary.detail.root.path,
      name: ETAB_ROUTES.dashboard.recruitment.temporary.detail.root.name,
      component: TemporaryDetailRoot,
      children: [
        {
          path: ETAB_ROUTES.dashboard.recruitment.temporary.detail.applied.path,
          name: ETAB_ROUTES.dashboard.recruitment.temporary.detail.applied.name,
          component: AppliedPage,
        },
        {
          path: ETAB_ROUTES.dashboard.recruitment.temporary.detail.selected.path,
          name: ETAB_ROUTES.dashboard.recruitment.temporary.detail.selected.name,
          component: SelectedPage,
        },
      ],
    },
  ];
}
